import { useTranslation } from 'react-i18next';
import { iconMap } from '../../data/resourceCategories';

/**
 * ResourceCategoryItem - Circular icon bubble for resource carousel
 * @param {Object} category - Category object with label, key, iconKey
 * @param {Function} onClick - Click handler for category selection
 */
const ResourceCategoryItem = ({ category, onClick }) => {
  const { t } = useTranslation();
  
  const IconComponent = iconMap[category.iconKey];
  
  return (
    <button
      onClick={() => onClick(category)}
      className="resource-item w-full flex flex-col items-center py-1 overflow-hidden
                 rounded-xl hover:bg-primary/5 transition-all duration-200 
                 active:scale-95"
      aria-label={t(category.label)}
    >
      {/* Icon Circle */}
      <div className="resource-icon rounded-full flex items-center justify-center 
                      bg-primary shadow-md flex-shrink-0
                      hover:shadow-lg hover:scale-105 
                      transition-all duration-200">
        <span className="resource-icon-inner text-primary-foreground flex items-center justify-center">
          {IconComponent}
        </span>
      </div>
      
      {/* Label */}
      <div className="resource-label-container w-full overflow-hidden mt-1.5 px-0.5">
        <span className="resource-label block font-medium text-foreground 
                         text-center leading-tight break-words
                         line-clamp-3"
                         style={{ hyphens: 'none', WebkitHyphens: 'none' }}>
          {t(category.label)}
        </span>
      </div>
    </button>
  );
};

export default ResourceCategoryItem;
